export const BASE_PATH = '/api';

export const PAGINATION_SIZE_DEFAULT = 999999;

export enum EQueryConst {
  // LIST
  LZ_SHORT_INFORMATION = 'lzShortInformation',
  PZU_SHORT_INFORMATION = 'pzuShortInformation',

  // USER
  CURRENT_USER = 'currentUser',
  GET_USER = 'getUser',
  GET_USERS = 'getUsers',
  GET_USERSV2 = 'getUsersV2',
  GET_PZU_ALLOW_USERS = 'getUsers',

  // LZ
  GET_LZ_COMMISSIONS = 'getLzCommissions',
  GET_SBER_API_COMMISSIONS = 'getSberApiCommissions',
  GET_LZ_COMMISSIONSV2 = 'getLzCommissionsV2',
  GET_LZ = 'lz',
  GET_LZ_LIST = 'getLzList',
  GET_PZUS_BY_LZ = 'getPzusByLz',
  GET_LZ_SETTINGS = 'getLzSettings',
  GET_FORBIDDEN_CLASSIFIERS = 'getForbiddenClassifiers',
  GET_CLASSIFIER_SETTINGS = 'getClassifierSettings',
  GET_FRONT_STORAGE = 'getFrontStorage',

  // METAL - TARIFF
  GET_LZ_METAL_PRICE = 'getLzMetalPrice',
  GET_PZU_METAL_TARIFF = 'getPzuMetalTariff',
  GET_METAL_TARIFF_BY_ID = 'getPzuMetalTariffById',
  GET_METAL_DICTIONARY = 'getMetalDictionary',
  GET_METAL_ANALYTICS = 'getMetalAnalytics',
  GET_METAL_VALUME = 'getMetalValume',
  GET_AVTIVE_CLASSIFIERS = 'getActiveClassifiers',

  // LZ - BUSINESS-CARD
  GET_LZ_BUSINESS_CARD = 'getLzBusinessCard',
  LZ_BUSINESS_CARD_CURRENT_PAGE = 'lzBusinessCardCurrentPage',

  // LZ - SBER_ID
  GET_LZ_SBER_ID = 'getLzSberId',
  GET_LZ_SBER_CREDENTIALS = 'getLzSberCredentials',

  // SBER_ID

  GET_LZ_IS_CONNECTED_TO_SBER_ID = 'getLzIsConnectedToSberId',
  GET_SBERID_LOGIN_URL = 'getSberIdLoginUrl',
  LOGOUT_SBERID = 'logoutSberId',
  GET_SBER_ID_SETTINGS = 'getSberIdSettings',
  GET_SBER_ID_STATUS = 'getSberIdStatus',
  GET_SBER_ID_USER_DATA = 'getSberIdUserData',
  UPDATE_SBER_ID_USER_DATA = 'updateSberIdUserData',
  GET_EDS_STATUS = 'getEdsStatus',
  GET_EDS_INFO = 'getEdsInfo',

  // PZU
  GET_PZU_LIST = 'getPzuList',
  GET_PZU = 'getPzu',
  CREATE_PZU = 'createPzu',
  PAYMENT_LIMITS_BALANCE = 'paymentLimitsBalance',

  // BUSINESS_CARD
  GET_BUSINESS_CARD = 'getBusinessCard',
  GET_USER_BUSINESS_CARD_TO_PZU = 'getUserBusinessCardToPzu',
  GET_PZU_BUSINESS_CARDS = 'getPzuBusinessCards',
  GET_PAYMENT_TOTAL = 'getPaymentTotal',

  // PERSONAL
  GET_PZU_PERSONAL = 'getPzuPersonal',

  // CLIENT
  GET_CITIZENSHIP_DICT_ITEMS = 'getCitizenShipDictItems',
  GET_LZ_CLIENTS = 'getLzClients',
  GET_LZ_CLIENT = 'getLzClient',
  GET_LZ_CLIENT_BY_ID = 'getLzClientById',
  GET_LZ_CLIENT_BY_IDS = 'getLzClientByIds',
  GET_LZ_CLIENT_BUSINESS_CARD = 'getLzClientBusinessCard',
  SET_CURRENT_LZ_CLIENT = 'currentLzClient',
  HAS_LZ_CLIENT_PAYMENTS = 'haslzClientPayments',
  GET_LZ_CLIENT_TRANSPORT = 'getLzClientTransport',
  GET_LZ_CLIENT_PAYMENT_PHONES = 'getLzClientPaymentPhones',

  // PSA
  GET_PSA_LIST = 'getPsaList',
  GET_PSA = 'getPsa',
  GET_PSA_ITEM = 'getPsaItem',
  GET_PSA_TOTAL = 'getPsaTotal',
  GET_PSA_PARTY_PAYMENTS = 'getPsaPartyPayments',
  GET_QR_CODE_MOBILE_UPLOAD = 'getQrCodeForMobileUpload',
  GET_LOADED_FILES = 'getLoadedFiles',

  // PAYMENT
  GET_PAYMENT_LIST = 'getPaymentList',
  GET_PAYMENT_ITEM = 'getPaymentItem',
  GET_PSA_PAYMENTS = 'getPsaPayments',
  GET_SMS_CODE = 'getSmsCode',

  // PASSPORT

  GET_PASSPORT_REPORT = 'getPassportInfno',

  // MAIL_LIST

  CREATE_MAIL_LIST = 'createMailList',
  GET_MAIL_LISTS = 'getMailLists',

  // TRANSACTION

  GET_TRANSACTION_LIST = 'getTransactionList',
  GET_TRANSACTION_INFO = 'getTransactionInfo',
  GET_TRANSACTION_MORE_INFO = 'getTransactionMoreInfo',
  GET_PZU_MONTHLY_VOLUME = 'getTransactionMoreInfo',

  // FILES

  RECOGNIZE_PASSPORT_SCAN = 'recognizePassportScan',

  // LS

  GET_LS_LIST = 'getLsList',
  GET_LS_LIST_INDEXES = 'getLsListIndexes',

  // NEWS

  GET_NEWS = 'getNews',

  // LZ_DOCUMENTS/
  SET_LZ_DOCUMENT = 'setLzDocument',
  GET_DOCUMENTS_BY_LZID = 'getDocumentsByLzId',

  GET_COMPLIANCE_DOCUMENTS_BY_LZ_ID = 'getComplianceDocumentsByLzId',
  DOWNLOAD_DOCUMENT = 'downloadDocument',

  // COUNTERPARTY
  GET_REPORT_BY_INN = 'getReportByInn',
  GET_REPORTS_BY_LZID = 'getLatestReportsByLzId',
  GET_REPORTS_BY_REPORTID = 'getReportsByReportId',
  GET_ALL_REPORTS = 'getAllReports',

  // Compliance
  GET_CURRENT_SETTINGS = 'getCurrentSettings',
  GET_DEFAULT_SETTINGS = 'getDefaultSettings',
  GET_SETTINGS_HISTORY = 'getSettingsHistory',
  GET_SETTINGS_BY_ID = 'getSettingsById',

  // VEHICLE
  GET_VEHICLE_MODLES = 'getVihicleModels',
  GET_VEHICLE_BRANDS = 'getVihicleBrands',

  // Group Commissions
  GET_GROUP_COMISSIONS_LIST = 'getGroupComissionsList',
  GET_COMMISSION_CHILDREN = 'getCommissionChildren',

  // VENDOE SETTINGS
  GET_VENDOR_SETTINGS = 'getVendorSettings',

  // COMMISSION DOCUMENTS
  GET_COMMISSION_DOCUMENTS = 'getCommissionDocuments',

  GET_BACKEND_VERSION = 'getBackendVersion',
}
